export function possiblyNegativeYearsBetweenDates(
  firstDate: Date,
  secondDate: Date
): number {
  const yearsSinceDate =
    (secondDate.getTime() - firstDate.getTime()) /
    (1000 * 60 * 60 * 24 * 365.25);
  return yearsSinceDate;
}
